module.exports = __webpack_public_path__ + "static/media/cherry2.8b1eb51f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/cherry2.svg
// module id = 1395
// module chunks = 0